module.exports = __webpack_public_path__ + "img/editLogo.701c09d4.svg";